import styled from 'styled-components';

const StyledBox = styled.div`
  align-self: flex-end;
`;

const ProfilePane = styled.div`
  position: absolute;
  width: 200px;
  height: 200px;
  background: #eee;
`;

const ProfileBoxLinks = styled.div`
  a {
    text-decoration: none;
    color: #fff;
    padding: 0 20px;
  }
`;

export { StyledBox, ProfilePane, ProfileBoxLinks };



// WEBPACK FOOTER //
// ./src/components/UI/ProfileBoxUI.tsx